"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingKitLine = void 0;
const common_1 = require("../../common");
const models_1 = require("../../sales-order/models");
class ShippingKitLine extends common_1.MongoSubDocument {
}
exports.ShippingKitLine = ShippingKitLine;
//# sourceMappingURL=shipping-kit-line.model.js.map